<template>
  <transition name="bounce">
    <div class="toast" :class="{'hidden': !visible}">
      <i class="message">{{message}}</i>
      <i class="icon icon-tuichu" @click="closeToast"></i>
    </div>
  </transition>
</template>
<script>
  export default {
    props:{
      message: {type:String,default:'提示消息'},
      visible: {type: Boolean, default: true},
      duration:{type:Number,default:2000}
    },
    data () {
      return {

      }
    },
    methods:{
      closeToast: function () {
        this.close();
      }
    }
  }
</script>
<style scoped >
  .toast{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
    display: table-cell;
    border-radius: 5px;
    padding: 20px;
    min-width: 120px;
    min-height: 60px;
    line-height: 60px;
    text-align:center;
    background: rgba(0, 0, 0, 0.5);
  }
  .icon-tuichu hover{
    display: inline-block;
  }
  .icon-tuichu{
    position: absolute;
    display: none;
    right: 8px;
    top: 8px;
    height: 16px;
    line-height: 16px;
    margin: 0;
  }
  .hidden {
    transform: scale(0);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/toast.vue